__turbopack_context__.v({
  "badge": "MiniProductCard-module-scss-module__WGiswW__badge",
  "card": "MiniProductCard-module-scss-module__WGiswW__card",
  "image": "MiniProductCard-module-scss-module__WGiswW__image",
  "imageWrapper": "MiniProductCard-module-scss-module__WGiswW__imageWrapper",
  "info": "MiniProductCard-module-scss-module__WGiswW__info",
  "link": "MiniProductCard-module-scss-module__WGiswW__link",
  "name": "MiniProductCard-module-scss-module__WGiswW__name",
  "originalPrice": "MiniProductCard-module-scss-module__WGiswW__originalPrice",
  "price": "MiniProductCard-module-scss-module__WGiswW__price",
  "priceRow": "MiniProductCard-module-scss-module__WGiswW__priceRow",
  "salePrice": "MiniProductCard-module-scss-module__WGiswW__salePrice",
  "title": "MiniProductCard-module-scss-module__WGiswW__title",
});
